import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
const INITIAL_SECONDS = 20 * 60; // 20 minutes
export function OfferCountdown() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? INITIAL_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const units = [{
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEG'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="w-full" data-id="element-117">
      {/* Header text */}
      <p className="text-center text-[11px] md:text-xs tracking-[0.22em] uppercase text-burgundy/70 font-medium mb-4" data-id="element-118">
        Oferta especial disponible por tiempo limitado
      </p>

      {/* Countdown boxes — only MM:SS */}
      <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-119">
        {units.map((unit, index) => <Fragment key={unit.label} data-id="element-120">
            <div className="flex flex-col items-center" data-id="element-121">
              <div className="bg-[#FDF2F0] border border-burgundy/15 rounded-xl px-5 py-3 md:px-6 md:py-4 min-w-[72px] md:min-w-[80px] shadow-sm" data-id="element-122">
                <motion.p key={unit.value} initial={{
              scale: 1.08,
              opacity: 0.7
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 22
            }} className="font-playfair text-3xl md:text-4xl font-light text-burgundy text-center tabular-nums leading-none" data-id="element-123">
                  {unit.value}
                </motion.p>
              </div>
              <p className="text-[10px] md:text-[11px] tracking-[0.18em] uppercase text-burgundy/60 font-medium mt-2" data-id="element-124">
                {unit.label}
              </p>
            </div>
            {index < units.length - 1 && <span className="font-playfair text-2xl md:text-3xl text-burgundy/40 -mt-5 font-light" data-id="element-125">
                :
              </span>}
          </Fragment>)}
      </div>

      {/* Footer text */}
      <p className="text-center text-[12px] md:text-sm italic text-charcoal/55 mt-4 font-light" data-id="element-126">
        Luego vuelve a su precio normal
      </p>
    </motion.div>;
}